import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Avatar, Box, Button, InputAdornment, Typography } from '@mui/material';
import { PersonIcon } from 'components/common/IconCommon';
import TextFieldVMP from 'components/common/TextField/TextFieldVMP';
import { PATH_ROOT } from 'constants/api';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';


export default function RegisterEmailNoSSO({emailAccount, onClickSubmit, username, setUserName, randomColor}) {
    const navigate = useNavigate();
    const {t, i18n} = useTranslation();
    const [validateUsername, setValidateUsername] = useState({value: true, text: ''})

    const hasSpecialCharacter = (inputString) => {
        let regex = /(?=.*[!@#$%^&*()+{}[\]:;<>,.?/|\\-])/;
        return regex.test(inputString);
    }

    const hasWhitespace = (inputString) => {
        let regex = /\s/;
        return regex.test(inputString);
    }
    
    const checkValidUsername = (string) => {
        if(hasSpecialCharacter(string)){
            setValidateUsername({value: false, text: t('validateInput.username.specialCharacters')});
            return;
        } else if(hasWhitespace(string)){
            setValidateUsername({value: false, text: t('validateInput.username.whiteSpace')});
            return;
        } else if(string.length > 64){
            setValidateUsername({value: false, text: t('validate.maxText')});
        } else {
            setValidateUsername({value: true, text: ''});
            return;
        }
    }

    const handleKeyDown = (e) => {
        if(e?.key === "Enter"){
            if(validateUsername.value && username.length > 0){
                onClickSubmit();
            }
        }
    }

    useEffect(() => {
        if(!emailAccount){
            // navigate(`${PATH_ROOT}/auth/login`)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        checkValidUsername(username)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [username, i18n.language])

    return (
        <>
            <Typography fontSize={28} fontWeight={600} textAlign={'center'} mb={3}>{t('dialog.create-account.title')}</Typography>
            <div className="body-create-account">
                <div className="avatar-account">
                    {
                        username 
                        ?
                        <Avatar className="avatar-account-image" variant="rounded" sx={{backgroundColor: `#${randomColor}`}}>
                            {username?.trim()?.slice(0, 1)?.toUpperCase()}
                        </Avatar>
                        :
                        <Avatar className="avatar-account-image" variant="rounded"/>
                    }
                    <Typography pl={1.25} sx={{ wordBreak: 'break-all'}}>{emailAccount}zzzzzzzzzzz</Typography>
                </div>
                <div className="username-account">
                    <Typography mb={1.5}>{t('dialog.create-account.text')}</Typography>
                    <TextFieldVMP
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <PersonIcon sx={{ color: '#949595' }} />
                                </InputAdornment>
                            ),
                        }}
                        error={!validateUsername?.value}
                        helperText={validateUsername?.text}
                        autoFocus={true}
                        value={username}
                        onChange={e => setUserName(e.target.value.trim())}
                        onKeyDown={handleKeyDown}
                    />
                </div>
                <div className="create-account-information">
                    <ErrorOutlineIcon sx={{ color: '#44494D', width: '20px'}} />
                    <Typography pl={1}>{t('dialog.create-account.warning-content')}</Typography>
                </div>
                <div className="create-account-button">
                    <Button
                        size="large"
                        type={'submit'}
                        variant="contained"
                        sx={{ mb: 2, mt: 3 }}
                        onClick={onClickSubmit}
                        disabled={!validateUsername.value || username.length === 0}
                        fullWidth
                    >
                        {t('dialog.create-account.button')}
                    </Button>
                    <Box>
                        <Typography>{t('dialog.create-account.has-account')}</Typography>
                        <Typography sx={{ cursor: 'pointer', textDecoration: 'underline', color: theme => theme.palette.primary.main }} tabIndex={0} onKeyDown={(e) => {if(e.key === "Enter"){navigate(`${PATH_ROOT}/auth/login`)}}} onClick={() => {navigate(`${PATH_ROOT}/auth/login`)}}>{t('dialog.create-account.login')}</Typography>
                    </Box>
                </div>
            </div>
        </>
    );
}
